import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const loneScale = defineConnector({
  identifier: "loneScale",
  name: "LoneScale",
  tagLine: "Sales intelligence",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://public-api\\.lonescale\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In your [LoneScale](https://app.lonescale.com/) account, navigate to **Settings → API** and copy your API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://public-api.lonescale.com/users",
  },
});
